// Defers loading of nav/megamenu thumbnail images until the user
// either interacts with the header (hover/touch/focus) or the
// browser is idle. Images opt in by carrying `data-lazy-src` instead
// of a real `src`. The placeholder src is a 1×1 transparent SVG so
// the layout stays stable and no network request fires.
(() => {
  const swap = (img) => {
    const src = img.getAttribute('data-lazy-src');
    if (!src) return;
    img.src = src;
    img.removeAttribute('data-lazy-src');
  };

  const hydrateAll = (root = document) => {
    root.querySelectorAll('img[data-lazy-src]').forEach(swap);
  };

  const headerEl = document.querySelector('.section-header, header, .header, .drawer--header');
  if (headerEl) {
    const onInteract = () => hydrateAll(headerEl);
    ['mouseenter', 'touchstart', 'focusin', 'click'].forEach((evt) => {
      headerEl.addEventListener(evt, onInteract, { once: true, passive: true });
    });
  }

  const idleHydrate = () => hydrateAll(document);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(idleHydrate, { timeout: 5000 });
  } else {
    setTimeout(idleHydrate, 4000);
  }
})();
